import styled from "@emotion/styled"
import Container from "@mui/material/Container"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import theme from "../../gatsby-theme-material-ui-top-layout/theme"

export const Section = styled(SectionWrapper)`
  &.jobs {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: ${({ theme }) => theme.fonts.primary};
      font-weight: 800;
    }
    ul {
      padding-left: 1rem;
    }
    li::marker {
      color: ${({ theme }) => theme.palette.primary.light};
    }
  }
`

export const Wrapper = styled(Container)`
  line-height: 28px;
  letter-spacing: 0.16px;
`
